export function singlePayloadReducer(type, initialState) {
    return (state = initialState, action) => {
        if (action.type === type) {
            return action.payload;
        }
        return state;
    };
}
